var eligibility = {
    disputeOpened: 'Dispute Opened',
    disputeOpenedPending: 'Please allow 60 minutes for dispute claim to appear in the Disputes Center.',
    pleaseVisitDisputeCenter: 'Please visit <0>Manage Disputes</0> for further details.',
    disputeCanceled: 'Dispute Canceled',
    cancelationPending: 'Cancelation Pending',
    disputeCompleted: 'Dispute Completed',
    disputeUnderReview: 'Dispute Under Review',
    disputeDetails: 'Dispute Details',
    cancelThisDispute: 'Cancel This Dispute',
    disputeThisTransaction: 'Dispute this Transaction',
    howToDispute: 'How can I dispute this transaction?',
    howToDisputeDescription: 'For dispute assistance, please contact us via <0>Online Chat</0> or at the number on your statement or the back of your card.',
    transactionEligibleError: "We're sorry, but we are currently experiencing issues determining the dispute status for this transaction. Please try again later."
};
export default eligibility;
//# sourceMappingURL=eligibility.js.map